import { message, Modal } from "antd";
import Image1Bg from "assets/investment/1.jpg";
import Image10Bg from "assets/investment/10.jpg";
import Image11Bg from "assets/investment/11.jpg";
import Image12Bg from "assets/investment/12.jpg";
import Image13Bg from "assets/investment/13.jpg";
import Image14Bg from "assets/investment/14.jpg";
import Image15Bg from "assets/investment/15.jpg";
import Image16Bg from "assets/investment/16.jpg";
import Image2Bg from "assets/investment/2.jpg";
import Image3Bg from "assets/investment/3.jpg";
import Image4Bg from "assets/investment/4.jpg";
import Image5Bg from "assets/investment/5.jpg";
import Image6Bg from "assets/investment/6.jpg";
import Image7Bg from "assets/investment/7.jpg";
import Image8Bg from "assets/investment/8.jpg";
import Image9Bg from "assets/investment/9.jpg";
import ImageArrow from "assets/investment/arrow.png";
import ImageBlock8Item1 from "assets/investment/block8-1.png";
import ImageBlock8Item2 from "assets/investment/block8-2.png";
import ImageBlock8Item3 from "assets/investment/block8-3.png";
import ImageBlock8Item4 from "assets/investment/block8-4.png";
import ImageBlock8Item5 from "assets/investment/block8-5.png";
import ImageBlock8Item6 from "assets/investment/block8-6.png";
import ImageBlcok8Banner1 from "assets/investment/block8-banner1.png";
import ImageBlcok8Banner2 from "assets/investment/block8-banner2.png";
import ImageBlcok8Banner3 from "assets/investment/block8-banner3.png";
import IconRemark from "assets/investment/remark.png";
import IconTel from "assets/investment/tel.png";
import IconUser from "assets/investment/user.png";
import LazyLoad from "components/scroll-wrapper";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Swiper, SwiperSlide } from "swiper/react";
import { budget } from "utils/budget";
import { useImgScale } from "utils/hook";
import http from "utils/http";
import { province } from "utils/province";
import ApiUrl from "utils/url";
import "./index.scss";
import SwiperCore, {
  Autoplay,
  Mousewheel,
  Navigation,
  Pagination,
} from "swiper";
SwiperCore.use([Pagination, Navigation, Autoplay, Mousewheel]);

export const InvestmentPage = () => {
  const [city, setCity] = useState<any[]>([]);
  const [area, setArea] = useState<any[]>([]);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    Modal.confirm({
      title: "提示",
      content: "请确认信息是否有误",
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        await http.post(ApiUrl.InvestmentSubmit, data);
        message.success("信息已提交！");
        reset();
      },
    });
  };

  return (
    <section className="investment-page-cotainer">
      <LazyLoad src={Image1Bg} autoRatio={1920 / 1080} />
      <LazyLoad src={Image2Bg} autoRatio={1920 / 1095} />
      <LazyLoad src={Image3Bg} autoRatio={1920 / 1106} />
      <LazyLoad src={Image4Bg} autoRatio={1920 / 1104} />
      <LazyLoad src={Image5Bg} autoRatio={1920 / 1115} />
      <LazyLoad src={Image6Bg} autoRatio={1920 / 1096} />
      <LazyLoad src={Image7Bg} autoRatio={1920 / 1103} />

      <section className="block8-wrap">
        <LazyLoad src={Image8Bg} autoRatio={1920 / 1096} />

        <section className="content">
          <h3 className="title">合作商业地产</h3>
          <section className="img-list">
            <section className="img-item">
              <section
                className="img"
                ref={useImgScale()}
                style={{ backgroundImage: `url(${ImageBlock8Item1})` }}
              ></section>
            </section>
            <section className="img-item">
              <section
                className="img"
                ref={useImgScale()}
                style={{ backgroundImage: `url(${ImageBlock8Item2})` }}
              ></section>
            </section>
            <section className="img-item">
              <section
                className="img"
                ref={useImgScale()}
                style={{ backgroundImage: `url(${ImageBlock8Item3})` }}
              ></section>
            </section>
            <section className="img-item">
              <section
                className="img"
                ref={useImgScale()}
                style={{ backgroundImage: `url(${ImageBlock8Item4})` }}
              ></section>
            </section>
            <section className="img-item">
              <section
                className="img"
                ref={useImgScale()}
                style={{ backgroundImage: `url(${ImageBlock8Item5})` }}
              ></section>
            </section>
            <section className="img-item">
              <section
                className="img"
                ref={useImgScale()}
                style={{ backgroundImage: `url(${ImageBlock8Item6})` }}
              ></section>
            </section>
          </section>
        </section>
      </section>
      <section className="block9-wrap">
        <LazyLoad src={Image9Bg} autoRatio={1920 / 1103} />

        <section className="content">
          <section className="desc-top">
            <section className="left">
              <h3 className="title">教育中心 孵化专业人才</h3>
              <p className="text">
                1500㎡ 我们每一个培训中心人将以爱为源，助推你飞向明亮那方……
              </p>
            </section>
            <section className="right">
              <section className="actions-btn">
                <img className="left-arrow" src={ImageArrow} alt="left-arrow" />
                <img
                  className="right-arrow"
                  src={ImageArrow}
                  alt="right-arrow"
                />
              </section>
            </section>
          </section>

          <section className="swiper-wrap">
            <Swiper
              loop={true}
              mousewheel={true}
              watchSlidesProgress={true}
              onSetTranslate={(swiper, translate) => {
                const slides = swiper.slides as any;
                for (let i = 0; i < slides.length; i++) {
                  const slide = slides.eq(i);
                  const progress = slides[i].progress;
                  slide.transform(
                    "scale(" + (1 - Math.abs(progress) / 6) + ")"
                  );
                }
              }}
              onSetTransition={(swiper, transition) => {
                const slides = swiper.slides as any;

                for (var i = 0; i < slides.length; i++) {
                  var slide = slides.eq(i);
                  slide.transition(transition);
                }
              }}
              navigation={{
                prevEl: ".left-arrow",
                nextEl: ".right-arrow",
              }}
            >
              <SwiperSlide>
                <div
                  className="swiper-content"
                  style={{ backgroundImage: `url(${ImageBlcok8Banner1})` }}
                ></div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="swiper-content"
                  style={{ backgroundImage: `url(${ImageBlcok8Banner2})` }}
                ></div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="swiper-content"
                  style={{ backgroundImage: `url(${ImageBlcok8Banner3})` }}
                ></div>
              </SwiperSlide>
            </Swiper>
          </section>
        </section>
      </section>

      <LazyLoad src={Image10Bg} autoRatio={1920 / 1106} />
      <LazyLoad src={Image11Bg} autoRatio={1920 / 1110} />
      <LazyLoad src={Image12Bg} autoRatio={1920 / 1110} />
      <LazyLoad src={Image13Bg} autoRatio={1920 / 1101} />
      <LazyLoad src={Image14Bg} autoRatio={1920 / 1103} />
      <LazyLoad src={Image15Bg} autoRatio={1920 / 1108} />

      <section className="block16-wrap">
        <LazyLoad src={Image16Bg} autoRatio={1920 / 1114} />

        <section className="content">
          <h1 className="title">投资在线咨询</h1>
          <form onSubmit={handleSubmit(onSubmit)}>
            <section
              className={`block-item${errors.contact_name ? " error" : ""}`}
            >
              <section className="label">联系人</section>
              <section className="line"></section>
              <input
                {...register("contact_name", { required: true })}
                placeholder="请输入您的姓名"
              />
              <img className="icon" src={IconUser} alt="user" />
            </section>

            <section
              className={`block-item${errors.contact_mobile ? " error" : ""}`}
            >
              <section className="label">联系电话</section>
              <section className="line"></section>
              <input
                {...register("contact_mobile", {
                  required: true,
                  pattern:
                    /^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/,
                })}
                placeholder="请输入您的手机号码"
              />
              <img className="icon" src={IconTel} alt="user" />
            </section>

            <section
              className={`block-item${
                errors.province || errors.city || errors.area ? " error" : ""
              }`}
            >
              <section className="label">加盟城市</section>
              <section className="line"></section>
              <section className="select-content">
                <select
                  {...register("province", { required: true })}
                  onChange={(e) => {
                    setCity(
                      e.target.selectedIndex
                        ? province[e.target.selectedIndex - 1]["city"]
                        : []
                    );
                    setArea([]);
                    setValue("province", e.target.value);
                    setValue("city", "");
                    setValue("area", "");
                    // trigger(['province', 'city', 'area'])
                  }}
                >
                  <option value="">请选择</option>
                  {province.map((item) => (
                    <option value={item.name} key={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
                <select
                  {...register("city", { required: true })}
                  onChange={(e) => {
                    setArea(
                      e.target.selectedIndex
                        ? city[e.target.selectedIndex - 1]["districtAndCounty"]
                        : []
                    );
                    setValue("city", e.target.value);
                    setValue("area", "");
                    // trigger(['province', 'city', 'area'])
                  }}
                >
                  <option value="">请选择</option>
                  {city.map((item) => (
                    <option value={item.name} key={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
                <select
                  {...register("area", { required: true })}
                  onChange={(e) => {
                    setValue("area", e.target.value);
                    trigger(["province", "city", "area"]);
                  }}
                >
                  <option value="">请选择</option>
                  {area.map((text) => (
                    <option value={text} key={text}>
                      {text}
                    </option>
                  ))}
                </select>
              </section>
            </section>

            <section
              className={`block-item${errors.invest_amount ? " error" : ""}`}
            >
              <section className="label">投资预算</section>
              <section className="line"></section>
              <section className="select-content">
                <select {...register("invest_amount", { required: true })}>
                  <option value="">请选择</option>
                  {budget.map((item) => (
                    <option value={item.name} key={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </section>
            </section>

            <section className="block-item">
              <section className="label">备注说明</section>
              <section className="line"></section>
              <textarea {...register("remark")} placeholder="请输入留言内容" />
              <img className="icon" src={IconRemark} alt="user" />
            </section>

            <section className="block-item submit-btn">
              <input type="submit" value="立即提交" />
            </section>
          </form>
        </section>
      </section>
    </section>
  );
};

export const investmentRoute = {
  path: "investment",
  component: InvestmentPage,
};
